export const seasonInfoKeys = {
	seasonInfo: (organizationUuid: string, teamLeagueUuid: string) => [`SEASON_INFO`, organizationUuid, teamLeagueUuid] as const
} as const;
